module.exports = __webpack_public_path__ + "static/media/ugpgBanner2.19dfd60b.png";